export const PAYMENT_SLIP_POLICIES = ['NONE', 'OPTIONAL', 'REQUIRED'];

export const normalizePolicy = (policy) => {
  const value = String(policy || 'OPTIONAL').toUpperCase();
  return PAYMENT_SLIP_POLICIES.includes(value) ? value : 'OPTIONAL';
};

export const hasUploadedSlip = (entity) => (entity?.paymentSlips || []).length > 0;

export const hasVerifiedSlip = (entity) => (entity?.paymentSlips || []).some((s) => s.isVerified);

export const slipRequired = (policy) => normalizePolicy(policy) === 'REQUIRED';

export const slipAllowsUpload = (policy) => normalizePolicy(policy) !== 'NONE';

export const getPaymentPolicy = (entity) =>
  normalizePolicy(entity?.payment?.paymentSlipPolicy || entity?.paymentSlipPolicy);

export const salonBlockedBySlip = (entity, policy) =>
  slipRequired(policy) && !hasUploadedSlip(entity);
